module.exports = __webpack_public_path__ + "static/media/manOnTable.1db266f4.svg";